export const PRODUCT_RECOMMENDATION_ENDPOINTS = {
  PENSION: '/recommendations/apv-with-insurance/',
  EDUCATION: '/recommendations/insured-university/',
  PROJECTS: '/recommendations/full-flexible/',
};
